<template>
  <footer class="footer">
    <div class="WhatsApp">
      <a href="http://wa.link/zp096a"><img src="@/assets/images/HOME/WhatsApp-Logo-Icon@2x.png" alt="" target="_blank"></a>
    </div>

    <div class="container">
      <div class="foot-cont">
        <div class="foot-left">
          <div class="wrp">
            <div class="foot-logo-mob">
              <img src="@/assets/images/GeneralAssets/LogoGiveAndGet.svg" alt="">
            </div>
            <div class="ul-wrp">
            <ul class="foot-ul">
              <li><router-link :to="{ name: 'Accounts' }">{{ $tc('home_page.footer_link1') }}</router-link></li>
              <li><router-link :to="{ name: 'Contact' }">{{ $tc('home_page.footer_link4') }}</router-link></li>
            </ul>
            <ul class="foot-ul">
              <li><router-link :to="{ name: 'Rewards' }">{{ $tc('home_page.footer_link2') }}</router-link></li>
              <li><router-link :to="{ name: 'Support' }">{{ $tc('home_page.footer_link5') }}</router-link></li>
            </ul>
            <ul class="foot-ul">
              <li><router-link :to="{ name: 'WhoWeAre' }">{{ $tc('home_page.footer_link3') }}</router-link></li>
              <li><router-link :to="{ name: 'Home' }">{{ $tc('home_page.footer_link6') }}</router-link></li>
            </ul>
            <ul class="foot-ul">
             <li><a href="https://tangod10s.com" target="_blank">Tango D10S</a></li>
            </ul>
            </div>

            <div class="f-img-wrap mob">
            <img src="@/assets/images/GeneralAssets/Fotter/Grupo 1578@2x.png" alt="">
            </div>

            <div class="socials">
              <div class="soc-icon">
                <a href="#" target="_blank"><img src="@/assets/images/GeneralAssets/Fotter/Grupo 1680@2x.png" alt=""></a>
              </div>
              <div class="soc-icon">
                <a href="#" target="_blank"><img src="@/assets/images/GeneralAssets/Fotter/Grupo 596@2x.png" alt=""></a>
              </div>
              <div class="soc-icon">
                <a href="#" target="_blank"><img src="@/assets/images/GeneralAssets/Fotter/Grupo 1679@2x.png" alt=""></a>
              </div>
            </div>

            <div class="disclaimer">
                <p>{{ $tc('home_page.footer_disclaimer') }}</p>
            </div>

            <div class="btm-logo">
              <img src="@/assets/images/GeneralAssets/LogoGiveAndGet.svg" alt="">
              <h4> &#169; {{ year }} | {{ $tc('home_page.copy_r') }} | <small><a href="https://secure.giveandget.io/terms" target="_blank">Terms & Conditions</a> | <a href="https://secure.giveandget.io/privacy" target="_blank">Privacy</a></small></h4>
              <h5></h5>
            </div>
          </div>
        </div>
        <div class="foot-right">
          <div class="f-img-wrap">
            <img src="@/assets/images/GeneralAssets/Fotter/Grupo 1578@2x.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
